import { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

import { MoroccoForm } from "../NewForm/MoroccoForm";
import SuccessfullMessage from "../NewForm/SuccessfullMessage";

import signBanner from "../../assets/images/compressImage.jpg";
import barcode from "../../assets/images/barcode.png";
import googleButton from "../../assets/images/googleButton.png";
import appleButton from "../../assets/images/appleButton.png";
import mobileFrame from "../../assets/images/mobileFrame.png";

import "react-toastify/dist/ReactToastify.css";
import "../NewForm/flags.css";

import "./GodoForm.css"; // Assuming you have a CSS file for styling
import LanguageTranslation from "../NewForm/LanguageTranslation";
import FormTypes from "../NewForm/FormTypes";
import Loader from "./Loader";

const GodoForm = () => {
  const [submittedData, setSubmittedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState("Corporate");
  const [button, setButton] = useState("");

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const device = searchParams.get("device");

    if (device) {
      setButton(device);
    }

  }, [])

  return (
    <div
      className="d-sm-flex IndividuallayoutContainer formDimission" // Full height container
    >
      <Col
        md={6}
        className={`position-relative p-0 ${submittedData ? "d-none" : "d-block"
          } d-sm-none`}
      >
        <img
          src={mobileFrame}
          alt="mobileFrame"
          style={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
          }}
        />
        <div className="mobileLinkWrapper position-absolute d-flex gap-3 align-items-center">
          {button === 'IOS' ? <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
            <img src={appleButton} alt="appleButton" />
          </a> : button === 'ANDROID' ?
            <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
              <img src={googleButton} alt="googleButton" />
            </a> :
            <>
              <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
                <img src={appleButton} alt="appleButton" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
                <img src={googleButton} alt="googleButton" />
              </a>
            </>
          }
        </div>
      </Col>

      {/* LEFT SCROLLABLE FORM COLUMN */}
      <Col
        md={6}
        className="scrollableFormSection" // scrollable left
      >
        {!submittedData && !loading ? (
          <>
            <div className="d-flex justify-content-center justify-content-lg-between">
              <a
                href="https://www.godocm.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://www.godocapitalmarkets.com/wp-content/uploads/2025/05/cropped-GoDo-Logo-7-1.png"
                  alt="logo"
                  className="d-none d-lg-block mt-2 mb-lg-4 mb-lg-0"
                  style={{ width: "70px", height: "70px" }}
                />
              </a>
              <div className="d-flex gap-4 mt-3 mt-lg-0 justify-content-center justify-content-sm-end align-items-center">
                <LanguageTranslation />
                <FormTypes className="logoCss" setFormType={setFormType} />
              </div>
            </div>

            <Row style={{ alignItems: "center", marginBottom: "8px" }}>
              <Col
                md={12}
                className={`${i18n.language === "ar" || i18n.language === "ir"
                  ? "text-end d-flex flex-column justify-content-end align-items-end"
                  : ""
                  } text-lg-start mt-4 mt-lg-2`}
              >
                <h3 className="fw-bold">{t("CreateYourAccount")}</h3>
                <p className="mb-0">{t("AchievingYourFinancialGoals")}</p>
              </Col>
            </Row>

            <MoroccoForm
              setSubmittedData={setSubmittedData}
              setLoading={setLoading}
            />
          </>
        ) : loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <Loader />
            {/* You can replace this with a spinner component */}
          </div>
        ) : (
          <SuccessfullMessage submittedData={submittedData} />
        )}
      </Col>

      {/* RIGHT STICKY IMAGE COLUMN */}
      <Col md={6} className="position-relative p-0 d-none d-sm-block">
        <div
          style={{
            position: "sticky",
            top: 0,
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <img
            src={signBanner}
            alt="godoBanner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <Col
            md={8}
            className="position-absolute"
            style={{ top: "32px", left: "20px" }}
          >
            <div className="bannerHeading text-white px-4">
              <h1>GODO All-in-One App for Traders</h1>
              <p>Everything you Need. One Powerful App.</p>
            </div>
          </Col>
          <Col
            md={4}
            className="position-absolute d-flex align-items-center gap-4 linksContainer"
          >
            <div className="linkWrapper d-flex flex-column gap-3 align-items-center">
              {button === 'IOS' ? <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
                <img src={appleButton} alt="appleButton" />
              </a> : button === 'ANDROID' ?
                <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
                  <img src={googleButton} alt="googleButton" />
                </a> :
                <>
                  <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
                    <img src={appleButton} alt="appleButton" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
                    <img src={googleButton} alt="googleButton" />
                  </a>
                </>
              }
            </div>
            <img className="barcode" src={barcode} alt="barcode" />
          </Col>
        </div>
      </Col>

      <ToastContainer />
    </div>
  );
};

export default GodoForm;
